import * as React from 'react'
import { ReactElement } from 'react'
import { Button, DialogActions, DialogTrigger } from '@fluentui/react-components'
import { CheckmarkRegular, DismissRegular } from '@fluentui/react-icons'
import { LineItemGroupDialogProps } from './LineItemGroupDialog'
import { FieldArrayRenderProps } from 'formik/dist/FieldArray'
import { useTranslation } from 'react-i18next'

export function Actions(props: LineItemGroupDialogProps & FieldArrayRenderProps): ReactElement {
    const { t: translate } = useTranslation()

    return (
        <DialogActions>
            <DialogTrigger disableButtonEnhancement>
                <Button appearance="transparent" icon={<DismissRegular />}>
                    {translate('action.cancel')}
                </Button>
            </DialogTrigger>
            <Button
                appearance="primary"
                icon={<CheckmarkRegular />}
                onClick={() => {
                    props.replace(props.index, props.values)
                    props.setOpen(false)
                }}
            >
                {translate('action.save')}
            </Button>
        </DialogActions>
    )
}
